import type {
	CustomItem,
	DropProductCardsType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropProductCards = (
	item: Item | CustomItem
): item is DropProductCardsType => {
	return !!(item && item.__typename === 'Drop_Product_Cards');
};
